import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";

export { default as Card } from "./Card.vue";
export { default as CardAction } from "./CardAction.vue";
export { default as CardContent } from "./CardContent.vue";
export { default as CardDescription } from "./CardDescription.vue";
export { default as CardFooter } from "./CardFooter.vue";
export { default as CardHeader } from "./CardHeader.vue";
export { default as CardTitle } from "./CardTitle.vue";

export const cardVariants = cva(
  "bg-card text-card-foreground flex flex-col gap-2 rounded-xl border py-5 md:py-6",
  {
    variants: {
      shadow: {
        none: "",
        sm: "shadow-sm",
        md: "shadow-md",
        lg: "shadow-lg",
      },
      border: {
        default: "border",
        subtle: "border border-border/70",
        none: "border-0",
      },
      clickable: {
        false: "",
        true: "transition-colors hover:bg-accent/40 hover:border-accent/50 cursor-pointer focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50",
      },
    },
    defaultVariants: {
      shadow: "sm",
      border: "default",
      // @ts-expect-error - string literal for variant
      clickable: "false",
    },
  },
);

export type CardVariants = VariantProps<typeof cardVariants>;
